/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import { useState } from "react";
import { useCreateGroupMutation, useGetGroupsQuery } from "../../../store/api/devices/deviceApiSlice";
import { setBasicDialogOpenFor, setOpenToast } from "../../../store/helpers/helperReducers";
import { useStoreDispatch } from "../../../store/hooks";
import { useSelector } from "react-redux";
import { groupListSelector } from "../../../store/api/admin/selectors";
import { IKeyValue } from "../types";
import { groupPayload } from "../helpers";
import { errorMessage } from "../../../utils/helpers";
import { Ioptions } from "../../Shared/Filter/types";

export const useNotificationGroupData = () => {
  const dispatch = useStoreDispatch();

  const groupList: Ioptions[] = useSelector(groupListSelector) || [];
  const [createGroup, groupStatus] = useCreateGroupMutation();
  const { refetch } = useGetGroupsQuery();

  const [errorMsg, setErrorMsg] = useState<IKeyValue>();
  const [groupData, setGroupData] = useState<IKeyValue>({
    groupName: "",
    domainKey: "Initial Domain",
  });

  const submitHandler = async () => {
    try {
      if(groupData.groupName ==="")
      {
        setErrorMsg({ ...errorMsg, groupName : "Group Name is required!"});
        return;
      }
      let result: any;
      //const nameExists = data?.some((group) => group.name.trim().toLowerCase() === groupData.groupName.trim().toLowerCase());
      const nameExists = groupList.some((group: Ioptions) => group.text.trim().toLowerCase() === groupData.groupName.trim().toLowerCase());
      if (nameExists) {
        dispatch(setOpenToast({ openToast: true, toastType: "error", message: `Group Notification:${groupData.groupName} already exists` }));
        return;
      }
      const payload = groupPayload(groupData);
      result = await createGroup(payload);
      if (result?.error || groupStatus.isError) throw result?.error;
      if (result.data?.status === 200 || result.data.name === groupData.groupName) {
        dispatch(setBasicDialogOpenFor(undefined));
        setGroupData({ groupName: "", domainKey: "Initial Domain" });
        dispatch(
          setOpenToast({
            openToast: true,
            toastType: "success",
            message: `Group Notification: ${groupData.groupName} created successfully`,
          })
        );
      }
      refetch();
    } catch (error: any) {
      dispatch(setBasicDialogOpenFor(undefined));
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
    }
  };

  return {
    dispatch,
    submitHandler,
    groupStatus,
    groupData,
    setGroupData,
    errorMsg,
    setErrorMsg,
  };
};
